<div class="container" [ngClass]="{'ionic': useIonic }">
    <div class="lists">
        <div class="trucking-shipments">
            <shared-trucking-shipments [selectedRouteExpand]="selectedRouteExpand"></shared-trucking-shipments>
        </div>
        <div class="trucking-routes">
            <shared-trucking-routes (clickItem)="onSelectedRoute($event)" (refreshRoute)="loadRouteExpand($event)"
                [selectedRoute]="selectedRouteExpand"></shared-trucking-routes>
        </div>
    </div>
    <shared-trucking-route-panel class="container-panel"
        [ngClass]="{'display-flex' : displayFlex, 'display-none' : !displayFlex}" [openPanel]="displayFlex"
        [selectedRouteExpand]="selectedRouteExpand" (clickBack)="onClickBack($event)"
        (updateRoute)="onSelectedRoute($event)">
    </shared-trucking-route-panel>
</div>